import React from 'react'
import Icon from './Icons'

const STEPS = [
  { number: 1, label: 'Votre projet' },
  { number: 2, label: 'Coordonnées' },
  { number: 3, label: 'Vérification' },
  { number: 4, label: 'Résultat' },
]

export default function ProgressBar({ currentStep }) {
  return (
    <div className="w-full px-2 sm:px-0">
      <div className="flex items-center justify-between relative">
        {/* Ligne de connexion */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-slate-200 z-0">
          <div
            className="h-full bg-blue-500 transition-all duration-500 ease-out"
            style={{ width: `${((currentStep - 1) / (STEPS.length - 1)) * 100}%` }}
          />
        </div>

        {STEPS.map((step) => {
          const isDone    = currentStep > step.number
          const isActive  = currentStep === step.number
          const isPending = currentStep < step.number

          return (
            <div key={step.number} className="flex flex-col items-center gap-1.5 z-10">
              {/* Cercle */}
              <div
                className={`
                  flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold
                  border-2 transition-all duration-300
                  ${isDone    ? 'bg-blue-600 border-blue-600 text-white' : ''}
                  ${isActive  ? 'bg-white border-blue-600 text-blue-600 shadow-[0_0_0_3px_rgb(59_130_246_/_0.2)]' : ''}
                  ${isPending ? 'bg-white border-slate-300 text-slate-400' : ''}
                `}
              >
                {isDone ? (
                  <Icon name="check" className="w-4 h-4" />
                ) : (
                  <span>{step.number}</span>
                )}
              </div>
              {/* Label */}
              <span
                className={`
                  text-xs font-medium hidden sm:block whitespace-nowrap
                  ${isActive  ? 'text-blue-600' : ''}
                  ${isDone    ? 'text-blue-500' : ''}
                  ${isPending ? 'text-slate-400' : ''}
                `}
              >
                {step.label}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
